// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1MYqA","type":"styles_type__2NNLS","choices":"styles_choices__olBGI"};